import C from "classnames";
import { Button } from "primereact/button";

import { themeClasses as T } from "sj-ui-toolkit/src/atlas/utils/themeClasses";

type Action = {
  label: string;
  icon?: string;
  iconPos?: "left" | "right" | "top" | "bottom";
  severity?: "secondary" | "success" | "info" | "warning" | "danger" | "help" | "contrast";
  className?: string;
  onClick: () => void;
  disabled?: boolean;
};

type ActionBarProps = {
  actions: Action[];
  message?: string;
};

const ActionBar = ({ actions, message }: ActionBarProps) => {
  return (
    <div
      className={C(
        T.rightPanelFooter,
        T.bgElevation2,
        "flex-none flex flex-row-reverse gap-4 rounded-bl-sm"
      )}
    >
      {actions.map((action, index) => (
        <Button
          key={index}
          severity={action.severity}
          icon={action.icon ? `pi pi-${action.icon}` : undefined}
          iconPos={action.iconPos ? action.iconPos : "left"}
          onClick={action.onClick}
          disabled={action.disabled}
          className={action.className}
          label={action.label}
        />
      ))}

      {message && <div className="mr-auto self-center">{message}</div>}
    </div>
  );
};

export default ActionBar;
